export default {
  TABLE: 'TABLE',
  PACKAGE: 'PACKAGE',
  TICKET: 'TICKET',
  COVER: 'COVER'
};



// WEBPACK FOOTER //
// ./src/constants/inventoryTypes.js